/**
 * Default text color for "old" website font themes (created before the color property existed).
 * Matches the previous browser default (#000) so users see the real state in the settings form.
 */
export const DEFAULT_WEBSITE_FONT_COLOR = 'rgb(0, 0, 0)';
